import React, { useEffect, useState } from "react";
import {
    Radio,
    Button,
    Space,
    Avatar,
    Modal,
    Empty,
    message,
    Spin
} from "antd";
import "./index.less";
import {
    MessageMarkdown,
} from "@sui/chat-ui";
import { Bubble } from '@ant-design/x';
import Logo from "../../assets/images/jiqiren.png";
import {
    DownOutlined,
    UpOutlined
} from "@ant-design/icons";
import agree from "../../assets/images/agree.svg";
import disagree from "../../assets/images/disagree.svg";
import useBaseRequest from "@/hooks/useBaseRequest";
import {
    getChatManageData,
    API
} from "@/api/index";
import { getUrlParam } from "@/utils/public";
import PieChart from "../message-cards/pie-chart";
import axios from "axios";




const { Group } = Radio

const Manage = () => {

    const [data, setData] = useState([])
    const [expandedStates, setExpandedStates] = useState({});
    const [wddopen, setWddOpen] = useState({})
    const [tjbzOpen, setTjbzOpen] = useState({})
    const [editbzOpen, setEditBzOpen] = useState({})
    const [wtglOpen, setWtglOpen] = useState({})
    const [bzzt, setBzzt] = useState("-1")
    const [fk, setfk] = useState("-1")
    const [ycjc, setycjc] = useState("-100")
    const [refresh, setRefresh] = useState("")
    const [spinning, setSpinning] = useState(true)
    const [bzztOptions, setBzztOptions] = useState([])
    const [fkOptions, setFkOptions] = useState([])
    const [ycjcOptions, setYcjcOptions] = useState([])

    const [saveData, setSaveData] = useState()





    window.closeModal = () => {
        setWddOpen({
            wddopen: false,
            item: {}
        })
        setTjbzOpen({
            tjbzOpen: false,
            item: {}
        })
        setEditBzOpen({
            editbzOpen: false,
            item: {}
        })
        setWtglOpen({
            wtglOpen: false,
            item: {}
        })
        setRefresh(Math.random())
    }

    window.queryAndAnswer = () => {
        return saveData
    }


    useEffect(() => {
        axios.get(API.getChatManageData + `?domainId=${getUrlParam("domainId")}&rows=-1&chatId=${getUrlParam("chatId") || ""}&handle=-1&score=-1&src=-100`).then((res) => {
            console.log(res);
            const data = res?.data?.data

            const arr1 = [] //未处理
            const arr2 = [] //已处理
            const arr3 = [] //踩
            const arr4 = [] //赞
            const arr5 = [] //异常出错
            const arr6 = [] //安全回答
            const arr7 = [] //疑似不准确
            for (let i = 0; i < data.length; i++) {
                if (data[i].handle === 0) {
                    arr1.push(data[i])
                }

            }
            for (let i = 0; i < data.length; i++) {
                if (data[i].handle === 1) {
                    arr2.push(data[i])
                }

            }

            for (let i = 0; i < data.length; i++) {
                if (data[i].score === 1) {
                    arr3.push(data[i])
                }

            }
            for (let i = 0; i < data.length; i++) {
                if (data[i].score === 5) {
                    arr4.push(data[i])
                }

            }
            for (let i = 0; i < data.length; i++) {
                if (data[i].src === -1) {
                    arr5.push(data[i])
                }

            }
            for (let i = 0; i < data.length; i++) {
                if (data[i].src === 15) {
                    arr6.push(data[i])
                }

            }
            for (let i = 0; i < data.length; i++) {
                if (data[i].src === 16) {
                    arr7.push(data[i])
                }

            }

            setBzztOptions([{
                // label: `全部（${arr1.length + arr2.length}）`,
                label: `全部（${data.length}）`,
                value: "-1"
            }, {
                label: `未处理（${arr1.length}）`,
                value: "0"
            }, {
                label: `已处理${arr2.length}）`,
                value: "1"
            }])

            setFkOptions([{
                // label: `全部（${arr3.length + arr4.length + arr8.length}）`,
                label: `全部（${data.length}）`,
                value: "-1"
            }, {
                label: `踩（${arr3.length}）`,
                value: "1"
            }, {
                label: `赞（${arr4.length}）`,
                value: "5"
            }])

            setYcjcOptions([{
                // label: `全部（${arr5.length + arr6.length + arr7.length}）`,
                label: `全部（${data.length}）`,
                value: "-100"
            }, {
                label: `异常出错（${arr5.length}）`,
                value: "-1"
            }, {
                label: `安全回答（${arr6.length}）`,
                value: "15"
            }, {
                label: `疑似不准确（${arr7.length}）`,
                value: "16"
            }])




        }).catch(() => {

        })
    }, [])

    useEffect(() => {
        axios.get(API.getChatManageData + `?domainId=${getUrlParam("domainId")}&rows=-1&chatId=${getUrlParam("chatId") || ""}&handle=${bzzt}&score=${fk}&src=${ycjc}`).then((res) => {
            console.log(res);
            const data = res?.data?.data
            const newArr = []
            data.forEach((item) => {
                newArr.push({
                    ...item,
                    qa: item?.qa ? JSON.parse(item.qa) : ""
                })
            })
            setData(newArr)
            setSpinning(false)
        }).catch(() => {

        })

    }, [bzzt, fk, ycjc, refresh])



    const toggleExpand = (index) => {
        setExpandedStates(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // 来源类型：-1 异常出错1知识库 2 数据库 3技能库，4 问答对 5 敏感词，6无效问法10门户搜索，11站群搜素12联网搜索13大模型生成 14 标注 15 安全回答
    const getSource = (num, item) => {
        if (num === -1) {
            return "异常出错"
        } else if (num === 1) {
            return `知识库 ${parseSource(num, item)}`
        } else if (num === 2) {
            return `数据库 ${parseSource(num, item)}`
        } else if (num === 3) {
            return `技能库 ${parseSource(num, item)}`
        } else if (num === 4) {
            return `问答对 ${parseSource(num, item)}`
        } else if (num === 5) {
            return "敏感词"
        } else if (num === 6) {
            return "无效问法"
        } else if (num === 10) {
            return `门户智搜 ${parseSource(num, item)}`
        } else if (num === 11) {
            return `站群智搜 ${parseSource(num, item)}`
        } else if (num === 12) {
            return `联网检索 ${parseSource(num, item)}`
        } else if (num === 13) {
            return "大模型生成"
        } else if (num === 14) {
            return "标注"
        } else if (num === 15) {
            return "安全回答"
        }
    }


    const parseSource = (num, _data) => {
        if (_data?.src && _data?.src?.[0]?.type === 1 || _data?.src?.[0]?.type === 2 || _data?.src?.[0]?.type === 3) {
            return _data?.docs ? (_data?.docs.length ? _data?.docs?.map((item) => {
                return `【${item?.name}】`
            }).join(",") : undefined) : (_data?.src.length ? _data?.src?.map((item) => {
                return `【${item?.name}】`
            }).join(",") : undefined)
        }

        if (num === 4) {
            if (_data?.knowledge_type && _data?.knowledge_type === "qa_pairs") {
                return `【${_data?.knowledge_title}】`
            }
        }

        if (_data?.src?.[0]?.type === 10 || _data?.src?.[0]?.type === 11 || _data?.src?.[0]?.type === 12 && _data?.search_items) {
            return `${_data.search_items.length} 条`
        }

        return ""

    }

    const getColor = (val) => {
        if (val * 1 < 60) {
            return "red"
        } else if (val > 80) {
            return "#52C41A"
        } else {
            return "#ffc107"
        }
    }


    return <>
        <div className="manage">
            {
                <Spin spinning={spinning}>
                    <div className="wrapcontent">
                        <div className="params">
                            <div className="listItem">
                                <span className="label">标注状态：</span>
                                <span className="value"><Group options={bzztOptions} defaultValue={bzzt} onChange={(e) => {
                                    setBzzt(e?.target?.value)
                                }} /></span>
                            </div>
                            <div className="listItem">
                                <span className="label">用户反馈：</span>
                                <span className="value"><Group options={fkOptions} defaultValue={fk} onChange={(e) => {
                                    setfk(e?.target?.value)
                                }} /></span>
                            </div>
                            <div className="listItem">
                                <span className="label">异常检测：</span>
                                <span className="value"><Group options={ycjcOptions} defaultValue={ycjc} onChange={(e) => {
                                    setycjc(e?.target?.value)
                                }} /></span>
                            </div>
                        </div>
                        <div className="manageContent">
                            <div className="scroll">
                                {
                                    (data && data.length) ? data.map((item, index) => {
                                        return <div className="list" key={index}>

                                            <div className="content">
                                                <div className="question">
                                                    <Bubble content={item.qa?.query} />
                                                </div>
                                                <div className="answer">

                                                    <div className="avatar">
                                                        <Avatar size={48} src={Logo} />
                                                    </div>
                                                    <div className="answerContent">
                                                        <div className="status">
                                                            {/* {
                                                                item?.src === 16 ? <span className="query">疑</span> : undefined
                                                            } */}
                                                            <span style={{
                                                                color: getColor(item.aiscore)
                                                            }}>{item.aiscore}</span>
                                                            {
                                                                item?.handle === 1 ? <span className="handleStatus">已处理</span> : undefined
                                                            }

                                                        </div>
                                                        <div className="markdown" >
                                                            {
                                                                item.src === 3 ? <>
                                                                    {
                                                                        item.qa?.form?.type === "link" ? undefined : <div className="markdownContent" style={{
                                                                            maxHeight: expandedStates[index] ? 'unset' : "220px",
                                                                            overflow: expandedStates[index] ? "unset" : "hidden",
                                                                            minHeight: "90px"
                                                                        }}>
                                                                            <MessageMarkdown children={item.qa?.answer} />
                                                                            {item?.qa?.chart && item.qa?.chart?.type ? <PieChart msg={item?.qa} /> : undefined}
                                                                        </div>
                                                                    }

                                                                    {
                                                                        item.qa?.form?.type === "link" ? <div className="type" style={{
                                                                            padding: "10px 0"
                                                                        }}>
                                                                            <div className="source">
                                                                                <span style={{
                                                                                    lineHeight: "16px"
                                                                                }}>来自：{getSource(item.src, item?.qa)}</span>
                                                                            </div>
                                                                            <div className="agree">
                                                                                {
                                                                                    item.score === 1 ? <span><span style={{
                                                                                        marginRight: "10px"
                                                                                    }}>{item.suggestion}</span><img style={{
                                                                                        width: "10px",
                                                                                        height: "10px"
                                                                                    }} src={disagree} alt=" " /></span> : undefined
                                                                                }

                                                                                {
                                                                                    item.score === 5 ? <span><img style={{
                                                                                        width: "10px",
                                                                                        height: "10px"
                                                                                    }} src={agree} alt=" " /></span> : undefined
                                                                                }

                                                                            </div>
                                                                        </div> : <div className={` ${expandedStates[index] ? "maskHidden" : "mask"}`}>
                                                                            <div
                                                                                className="action"
                                                                                onClick={() => toggleExpand(index)}
                                                                            >
                                                                                <span>{expandedStates[index] ? '收起' : '展开'}</span>
                                                                                {expandedStates[index] ? <UpOutlined /> : <DownOutlined />}
                                                                            </div>

                                                                            <div className="type">
                                                                                <div className="source">
                                                                                    <span style={{
                                                                                        lineHeight: "16px"
                                                                                    }}>来自：{getSource(item.src, item?.qa)}</span>
                                                                                </div>
                                                                                <div className="agree">
                                                                                    {
                                                                                        item.score === 1 ? <span><span style={{
                                                                                            marginRight: "10px"
                                                                                        }}>{item.suggestion}</span><img style={{
                                                                                            width: "10px",
                                                                                            height: "10px"
                                                                                        }} src={disagree} alt=" " /></span> : undefined
                                                                                    }

                                                                                    {
                                                                                        item.score === 5 ? <span><img style={{
                                                                                            width: "10px",
                                                                                            height: "10px"
                                                                                        }} src={agree} alt=" " /></span> : undefined
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }


                                                                </> : <>
                                                                    <div className="markdownContent" style={{
                                                                        maxHeight: expandedStates[index] ? 'unset' : "220px",
                                                                        overflow: expandedStates[index] ? "unset" : "hidden",
                                                                        minHeight: "90px"
                                                                    }}>
                                                                        <MessageMarkdown children={item.qa?.answer} />
                                                                        {item?.qa?.chart && item.qa?.chart?.type ? <PieChart msg={item?.qa} /> : undefined}
                                                                    </div>

                                                                    <div className={` ${expandedStates[index] ? "maskHidden" : "mask"}`}>
                                                                        <div
                                                                            className="action"
                                                                            onClick={() => toggleExpand(index)}
                                                                        >
                                                                            <span>{expandedStates[index] ? '收起' : '展开'}</span>
                                                                            {expandedStates[index] ? <UpOutlined /> : <DownOutlined />}
                                                                        </div>

                                                                        <div className="type">
                                                                            <div className="source">
                                                                                <span style={{
                                                                                    lineHeight: "16px"
                                                                                }}>来自：{getSource(item.src, item?.qa)}</span>
                                                                            </div>
                                                                            <div className="agree">
                                                                                {
                                                                                    item.score === 1 ? <span><span style={{
                                                                                        marginRight: "10px"
                                                                                    }}>{item.suggestion}</span><img style={{
                                                                                        width: "10px",
                                                                                        height: "10px"
                                                                                    }} src={disagree} alt=" " /></span> : undefined
                                                                                }

                                                                                {
                                                                                    item.score === 5 ? <span><img style={{
                                                                                        width: "10px",
                                                                                        height: "10px"
                                                                                    }} src={agree} alt=" " /></span> : undefined
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </>
                                                            }




                                                        </div>



                                                        <div className="footer">
                                                            <div className="cost">
                                                                <Space>
                                                                    <span>耗时：{item.time}&nbsp;s</span>
                                                                    <span>{item.createtime}</span>
                                                                </Space>

                                                                <Space>
                                                                    <span>分类：{item.aicategory}&nbsp;</span>
                                                                </Space>

                                                            </div>
                                                            <div className="actions">
                                                                <Space>
                                                                    <Button onClick={() => {
                                                                        const formData = new URLSearchParams()
                                                                        formData.append("idList", item.sid)
                                                                        formData.append('_method', 'PUT');
                                                                        axios.post(API.handleChatStatus + `?domainId=${getUrlParam("domainId")}&handleStatus=${item.handle === 0 ? 1 : 0}`, formData, {

                                                                            headers: {
                                                                                'Content-Type': 'application/x-www-form-urlencoded', // 明确设置表单格式
                                                                                'X-Requested-With': 'XMLHttpRequest'
                                                                            }
                                                                        }).then((res) => {
                                                                            if (res?.data?.resultCode === 0) {
                                                                                setRefresh(Math.random())
                                                                            } else {
                                                                                message.error(res?.data?.errorMsg)
                                                                            }
                                                                        })
                                                                    }}>{item.handle === 0 ? "设为已处理" : "设为未处理"}</Button>
                                                                    {
                                                                        (item.src === 3 || item.src === 2) ? undefined : <>
                                                                            {
                                                                                item.src === 4 ? <Button onClick={() => {
                                                                                    setWddOpen({
                                                                                        wddopen: true,
                                                                                        item,
                                                                                    })
                                                                                    setSaveData(item.qa)
                                                                                }}>编辑问答对</Button> : undefined
                                                                            }
                                                                            {
                                                                                item.src === 14 ? <Button onClick={() => {
                                                                                    setEditBzOpen({
                                                                                        editbzOpen: true,
                                                                                        item,
                                                                                    })
                                                                                    setSaveData(item.qa)
                                                                                }}>编辑标注</Button> : undefined
                                                                            }
                                                                            {
                                                                                (item.src !== 4 && item.src !== 14) ? <>
                                                                                    <Button disabled={item.annid ? true : false} onClick={() => {
                                                                                        setWtglOpen({
                                                                                            wtglOpen: true,
                                                                                            item
                                                                                        })
                                                                                        setSaveData(item.qa)
                                                                                    }}>问题关联</Button>
                                                                                    {
                                                                                        item.annid ? <Button disabled={item.assid ? true : false} onClick={() => {
                                                                                            setEditBzOpen({
                                                                                                editbzOpen: true,
                                                                                                item,
                                                                                            })
                                                                                        }}>编辑标注</Button> : <Button onClick={() => {
                                                                                            setTjbzOpen({
                                                                                                tjbzOpen: true,
                                                                                                item
                                                                                            })
                                                                                            setSaveData(item.qa)
                                                                                        }}>添加标注</Button>
                                                                                    }

                                                                                </> : undefined
                                                                            }
                                                                        </>
                                                                    }




                                                                </Space>

                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>


                                        </div>
                                    }) : <div style={{
                                        paddingTop: "30px"
                                    }}>
                                        <Empty description="暂无数据" />
                                    </div>
                                }
                            </div>


                        </div>
                    </div>
                </Spin>
            }


        </div>
        <Modal
            title="问题关联"
            open={wtglOpen?.wtglOpen}
            destroyOnClose={true}
            onClose={() => {
                setWtglOpen({})
            }}
            width={"80%"}
            onCancel={() => {
                setWtglOpen({})
            }}
            onOk={() => {
                const iframe = document.getElementById("wtglIframe");
                document.getElementById("wtglIframe")?.contentWindow?.childFunction.formSubmit()
            }}
        >
            <div style={{
                width: "100%",
                height: "370px"
            }}>
                <iframe id="wtglIframe" style={{
                    width: '100%',
                    height: "100%",
                    border: "unset"
                }} src={`../../chatloggl/linkQaEdit.jsp?domainId=${getUrlParam("domainId")}&chatsid=${wtglOpen?.item?.sid}`} ></iframe>
            </div>
        </Modal>
        <Modal
            title="编辑问答对"
            open={wddopen?.wddopen}
            destroyOnClose={true}
            onClose={() => {
                setWddOpen({})
            }}
            width={"80%"}
            onCancel={() => {
                setWddOpen({})
            }}
            onOk={() => {
                const iframe = document.getElementById("wddIframe");
                document.getElementById("wddIframe")?.contentWindow?.childFunction.formSubmit()
            }}
            className="modalStyle"
        >
            <div style={{
                width: "100%",
                height: "500px"
            }}>
                <iframe id="wddIframe" style={{
                    width: '100%',
                    height: "100%",
                    border: "unset"
                }} src={`../../zskgl/zskEdit.jsp?domainId=${getUrlParam("domainId")}&zskId=${wddopen?.item?.qa?.knowledge_id}&chatsid=${wddopen?.item?.sid}`} ></iframe>
            </div>
        </Modal>
        <Modal
            title="添加标注"
            open={tjbzOpen?.tjbzOpen}
            destroyOnClose={true}
            onClose={() => {
                setTjbzOpen({})
            }}
            width={"80%"}
            onCancel={() => {
                setTjbzOpen({})
            }}
            onOk={() => {
                const iframe = document.getElementById("tjbzIframe");
                document.getElementById("tjbzIframe")?.contentWindow?.childFunction.formSubmit()
            }}
            className="modalStyle"
        >
            <div style={{
                width: "100%",
                height: "500px"
            }}>
                <iframe id="tjbzIframe" style={{
                    width: '100%',
                    height: "100%",
                    border: "unset"
                }} src={`../../markzsgl/markzsEdit.jsp?domainId=${getUrlParam("domainId")}&zntId=${tjbzOpen?.item?.zntid}&chatsid=${tjbzOpen?.item?.sid}`} ></iframe>
            </div>
        </Modal>

        <Modal
            title="编辑标注"
            open={editbzOpen?.editbzOpen}
            destroyOnClose={true}
            onClose={() => {
                setEditBzOpen({})
            }}
            width={"80%"}
            onCancel={() => {
                setEditBzOpen({})
            }}
            onOk={() => {
                const iframe = document.getElementById("editIframe");
                document.getElementById("editIframe")?.contentWindow?.childFunction.formSubmit()

            }}
            footer={<>
                <Space>
                    <Button onClick={() => {
                        setEditBzOpen({})
                    }}>取消</Button>
                    <Button type="primary" onClick={() => {
                        const formData = new URLSearchParams()
                        formData.append("idList", editbzOpen?.item?.annid)
                        formData.append('_method', 'DELETE');
                        axios.post(API.deleteBz + `?domainId=${getUrlParam("domainId")}`, formData, {

                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded', // 明确设置表单格式
                                'X-Requested-With': 'XMLHttpRequest'
                            }
                        }).then((res) => {
                            if (res?.data?.resultCode === 0) {
                                setRefresh(Math.random())
                                setEditBzOpen({})
                            } else {
                                message.error(res?.data?.errorMsg)
                            }
                        })
                    }}>删除标注</Button>
                    <Button type="primary" onClick={() => {
                        document.getElementById("editIframe")?.contentWindow?.childFunction.formSubmit()

                    }}>确定</Button>
                </Space>
            </>}
            className="modalStyle"
        >
            <div style={{
                width: "100%",
                height: "500px"
            }}>
                <iframe id="editIframe" style={{
                    width: '100%',
                    height: "100%",
                    border: "unset"
                }} src={`../../markzsgl/markzsEdit.jsp?domainId=${getUrlParam("domainId")}&zskId=${editbzOpen.item?.src === 14 ? editbzOpen.item?.qa?.knowledge_id : editbzOpen?.item?.annid}`} ></iframe>
            </div>
        </Modal>

    </>
}

export default Manage
